import React from "react";
import Skeleton from "react-loading-skeleton";

const CheckoutPageSkeleton: React.FC = () => (
  <div className="checkout-page-container">
    <div className="checkout-page__header">
      <Skeleton width={300} height={36} />
      <Skeleton width={400} height={20} />
    </div>
    <div className="checkout-page__content">
      <div className="checkout-page__main">
        <Skeleton height={500} />
      </div>
      <div className="checkout-page__sidebar">
        <Skeleton height={300} />
      </div>
    </div>
  </div>
);

export default CheckoutPageSkeleton;
